import {
  PositionDataType,
  PositionRequestType
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllPositionService = async (
  params?: BaseFilterParams & {
    _name?: string;
    _provinceCode?: string
  },
): Promise<APIPaginationResponse<PositionDataType[]>> => {
  const res = await axiosInstance.get('positions', { params });
  return res.data;
};

export const getPositionByIdService = async (
  id: number,
): Promise<PositionDataType> => {
  const res = await axiosInstance.get(`positions/${id}`);
  return res.data.data;
};

export const createPositionService = async (
  params: PositionRequestType,
): Promise<void> => {
  await axiosInstance.post('positions', params);
};

export const updatePositionService = async (
  params: any & { id: number },
): Promise<void> => {
  const { id, ...rest } = params;
  await axiosInstance.put(`positions/${id}`, rest);
};

export const deletePositionsService = async (params: { ids: number[] })
  : Promise<void> => {
  const res = await axiosInstance.delete('positions', { data: params });
  return res.data;
};
